export const OUTSTANDING_SINGLE_PAYMENT_MARKUP: string = `
  <div class="payment_outstanding_info">
    <h4>Your original payment of {{currencySymbol}}{{paymentAmount}} due {{paymentDueDate}} has been unsuccessful</h4>
    <p>Retry the payment now or change your payment details.</p>
  </div>
`;

export const OUTSTANDING_MULTIPLE_PAYMENT_MARKUP: string = `
  <div class="payment_outstanding_info">
    <h4>Multiple payments for your policy totalling {{currencySymbol}}{{paymentAmount}} have been unsuccessful</h4>
    <p>Retry the payment now or change your payment details. All outstanding payments will be processed if you continue.</p>
  </div>
`;

export const OUTSTANDING_SINGLE_PAYMENT_FOR_UPDATE_MARKUP: string = `
  <div class="payment_outstanding_info">
    <h4>Your outstanding payment hasn't been automatically charged</h4>
    <p>You'll need to
      <a mat-button color="primary" href="/policy/payment/retry/{{policySlug}}">retry using your updated details</a>.
    </p>
  </div>
`;

export const OUTSTANDING_MULTIPLE_PAYMENT_FOR_UPDATE_MARKUP: string = `
  <div class="payment_outstanding_info">
    <h4>Your outstanding payments haven't been automatically charged</h4>
    <p>You'll need to
      <a mat-button color="primary" href="/policy/payment/retry/{{policySlug}}">retry using your updated details</a>.
    </p>
  </div>
`;

export const UPDATE_PAYMENT_LINK_MARKUP: string = `
  <div class="payment_update_link margin-top-xmedium">
  <a mat-button color="primary" class="small" href="/policy/payment/update/{{policySlug}}">
    <mat-icon class="credit_card material-icons-outlined align-bottom" color="primary"></mat-icon>
    Update payment details
    </a>
  </div>
`;

export const POLICY_DETAILS_REVIEW_MARKUP: string = `
  <div class="policy-details-review">
    <h4>{{coveredLabel}}</h4>
    <ul class="policy-details-review-list">
      <li><strong>{{policyTypeLabel}}</strong></li>
      <li>Policy number: <strong>{{policyNumber}}</strong></li>
    </ul>
  </div>
`;

export const CREDIT_CARD_REVIEW_MARKUP: string = `
  <div class="payment-review-details grid">
    <div class="cell cell-small-col-span-12 cell-large-col-span-12 payment-review-details-card-block">
      <img src="/assets/svgs/cards/{{icon}}" height="40" alt="" />
      <span>{{cardType}}</span>
      <span>{{cardNumber}}</span>
    </div>
  </div>
`;

export const DIRECT_DEBIT_REVIEW_MARKUP: string = `
  <div class="payment-review-details grid form-typography margin-bottom-small">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <label class="text-nowrap">Account name</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{accountName}}</p>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">{{accountType}}</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{bsb}}</p>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">Account number</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{accountNumber}}</p>
    </div>
  </div>
`;

export const CREDIT_CARD_SUCCESS_MARKUP: string = `
  <div class="payment-review-details grid">
    <div class="cell cell-small-col-span-12 cell-large-col-span-12 payment-review-details-card-block">
      <img src="/assets/svgs/cards/{{icon}}" height="40" alt="" />
      <span>{{cardType}}</span>
      <span>{{cardNumber}}</span>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">If there's any issues with future payments we'll let you know via the email address and mobile number you have provided to us.</div>
  </div>
`;

export const DIRECT_DEBIT_SUCCESS_MARKUP: string = `
  <div class="payment-review-details grid form-typography margin-bottom-small">
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">Account name</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{accountName}}</p>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">Financial institution</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{bankName}}</p>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">{{accountType}}</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{bsb}}</p>
    </div>
    <div class="cell cell-small-col-span-6 cell-large-col-span-6">
      <label class="text-nowrap">Account number</label>
      <p class="text-nowrap margin-top-xxsmall margin-bottom-none">{{accountNumber}}</p>
    </div>
  </div>
`;

export const SOSURE_PREAMBLE_BACS_MARKUP: string = `
  <h4 class="margin-bottom-xsmall">Hi {{customer}}</h4>
  <p class="text-blackMatte">Please update your payment details using the form below. These payment details will be used for any remaining payments on your policy.</p>
  <p class="text-blackMatte">If you have any concerns or need help, please contact our Customer Support Team. We&apos;re here to help.</p>
`;

export const SOSURE_PREAMBLE_NONE_MARKUP: string = `
  <h4 class="margin-bottom-xsmall">Hi {{customer}}</h4>
  <p class="text-blackMatte">Please update your payment details using the form below. These payment details will be used for any remaining payments on your policy.</p>
  <p class="text-blackMatte">If you have any concerns or need help, please contact our Customer Support Team. We're here to help.</p>
`;
